// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OperateLogOutlinedSvg from "@fishx/icons-svg/es/asn/OperateLogOutlined";
import FishxIcon from '../components/FishxIcon';

var OperateLogOutlined = function OperateLogOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: OperateLogOutlinedSvg
  }));
};

OperateLogOutlined.displayName = 'OperateLogOutlined';
export default React.forwardRef(OperateLogOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/OperateLogOutlined.js
// module id = 3181
// module chunks = 0